/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are these passwords really random?`)
};

const es_pw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Son realmente aleatorias estas contraseñas?`)
};

const de_pw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind diese Passwörter wirklich zufällig?`)
};

const nl_pw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zijn deze wachtwoorden echt willekeurig?`)
};

const fr_pw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ces mots de passe sont-ils vraiment aléatoires?`)
};

const it_pw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queste password sono davvero casuali?`)
};

const pt_br2_pw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essas senhas são realmente aleatórias?`)
};

const pt_pw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estas senhas são realmente aleatórias?`)
};

const ja_pw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本当にランダムなパスワードですか?`)
};

const zh_pw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些密码真的是随机的吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_faq1_q", locale)
	if (locale === "en") return en_pw_faq1_q(inputs)
	if (locale === "es") return es_pw_faq1_q(inputs)
	if (locale === "de") return de_pw_faq1_q(inputs)
	if (locale === "nl") return nl_pw_faq1_q(inputs)
	if (locale === "fr") return fr_pw_faq1_q(inputs)
	if (locale === "it") return it_pw_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_pw_faq1_q(inputs)
	if (locale === "pt") return pt_pw_faq1_q(inputs)
	if (locale === "ja") return ja_pw_faq1_q(inputs)
	return zh_pw_faq1_q(inputs)
};